module.exports = __webpack_public_path__ + "static/media/lock.fbcda4c8.svg";